/**
 * 弹窗焦点锁管理器
 *
 * 用于解决以下问题：
 * 快速切换导航后立即按退出键拉起弹窗时，导航的防抖定时器或路由变化触发的 setFocus
 * 会抢夺弹窗的焦点，导致焦点在底部页面而不是弹窗上。
 *
 * 解决方案：
 * 1. 弹窗显示时，调用 lock() 设置锁定状态
 * 2. 弹窗关闭时，调用 unlock() 解除锁定
 * 3. 所有可能与弹窗焦点冲突的 setFocus 调用前，先检查 isLocked()
 * 4. 如果被锁定，跳过该 setFocus 调用
 */

class DialogFocusLockManager {
  private locked = false;
  private lockTimestamp = 0;

  /**
   * 锁定焦点，阻止其他组件设置焦点
   */
  lock(): void {
    this.locked = true;
    this.lockTimestamp = Date.now();
    console.log('[DialogFocusLock] 焦点已锁定');
  }

  /**
   * 解除焦点锁定
   */
  unlock(): void {
    this.locked = false;
    console.log('[DialogFocusLock] 焦点已解锁');
  }

  /**
   * 检查是否处于锁定状态
   */
  isLocked(): boolean {
    return this.locked;
  }

  /**
   * 获取锁定时间戳（用于调试）
   */
  getLockTimestamp(): number {
    return this.lockTimestamp;
  }
}

// 导出单例
export const dialogFocusLock = new DialogFocusLockManager();
